import { Snackbar, Alert, AlertTitle } from '@mui/material';

export function Toast({onClose, title, content, severity}: {onClose: () => void, title?: string, content: string | null, severity: 'error' | 'warning' | 'info' | 'success'}) {
  const getSeverityStyles = (severity: string) => {
    switch (severity) {
      case 'error':
        return {
          boxShadow: '0 8px 32px rgba(220, 38, 38, 0.15)',
          border: '1px solid #fecaca',
          background: 'linear-gradient(135deg, #fef2f2 0%, #ffffff 100%)',
          '&::before': {
            background: 'linear-gradient(135deg, #dc2626, #b91c1c)'
          },
          '& .MuiAlert-icon': {
            color: '#dc2626'
          },
          '& .MuiAlert-message': {
            color: '#7f1d1d'
          },
          '& .MuiAlertTitle-root': {
            color: '#991b1b'
          }
        };
      case 'warning':
        return {
          boxShadow: '0 8px 32px rgba(245, 158, 11, 0.15)',
          border: '1px solid #fed7aa',
          background: 'linear-gradient(135deg, #fffbeb 0%, #ffffff 100%)',
          '&::before': {
            background: 'linear-gradient(135deg, #f59e0b, #d97706)'
          },
          '& .MuiAlert-icon': {
            color: '#f59e0b'
          },
          '& .MuiAlert-message': {
            color: '#92400e'
          },
          '& .MuiAlertTitle-root': {
            color: '#78350f'
          }
        };
      case 'info':
        return {
          boxShadow: '0 8px 32px rgba(59, 130, 246, 0.15)',
          border: '1px solid #bfdbfe',
          background: 'linear-gradient(135deg, #eff6ff 0%, #ffffff 100%)',
          '&::before': {
            background: 'linear-gradient(135deg, #3b82f6, #2563eb)'
          },
          '& .MuiAlert-icon': {
            color: '#3b82f6'
          },
          '& .MuiAlert-message': {
            color: '#1e40af'
          },
          '& .MuiAlertTitle-root': {
            color: '#1e3a8a'
          }
        };
      case 'success':
        return {
          boxShadow: '0 8px 32px rgba(34, 197, 94, 0.15)',
          border: '1px solid #bbf7d0',
          background: 'linear-gradient(135deg, #f0fdf4 0%, #ffffff 100%)',
          '&::before': {
            background: 'linear-gradient(135deg, #22c55e, #16a34a)'
          },
          '& .MuiAlert-icon': {
            color: '#22c55e'
          },
          '& .MuiAlert-message': {
            color: '#15803d'
          },
          '& .MuiAlertTitle-root': {
            color: '#166534'
          }
        };
      default:
        return {};
    }
  };

  return <Snackbar
    open={!!content}
    autoHideDuration={8000}
    onClose={onClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    sx={{
      '& .MuiAlert-root': {
        borderRadius: '16px',
        ...getSeverityStyles(severity),
        '&::before': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: '4px',
          borderRadius: '16px 0 0 16px',
          ...getSeverityStyles(severity)['&::before']
        }
      }
    }}
  >
    <Alert 
      onClose={onClose} 
      severity={severity}
      sx={{
        width: '100%',
        minWidth: '320px',
        maxWidth: '400px',
        '& .MuiAlert-icon': {
          ...getSeverityStyles(severity)['& .MuiAlert-icon']
        },
        '& .MuiAlert-message': {
          ...getSeverityStyles(severity)['& .MuiAlert-message']
        },
        '& .MuiAlertTitle-root': {
          fontWeight: 600,
          ...getSeverityStyles(severity)['& .MuiAlertTitle-root']
        }
      }}
    >
      {title && <AlertTitle>{title}</AlertTitle>}
      {content}
    </Alert>
  </Snackbar>
}
